import type { OffcardReportGroup, OffcardReportQuery } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import { formatMoney } from '../../../../../shared/policies/format-money';

interface BuildOffcardColumnsArgs {
  list: Pick<ListQueryControls<OffcardReportQuery>, 'sortOrderFor'>;
}

const MONTH_FORMAT = new Intl.DateTimeFormat('en-KE', { month: 'short', year: 'numeric', timeZone: 'UTC' });

/** Each sortable column's `key` is its `sort` field in `offcardReportQuerySchema`. */
export function buildOffcardColumns({ list }: BuildOffcardColumnsArgs): TableColumnsType<OffcardReportGroup> {
  return [
    { title: 'Customer', key: 'customer', dataIndex: 'customerName' },
    {
      title: 'Lane',
      key: 'originZoneCode',
      sorter: true,
      sortOrder: list.sortOrderFor('originZoneCode'),
      render: (_, group) => `${group.originZoneCode} → ${group.destinationZoneCode}`,
    },
    { title: 'Job type', key: 'jobTypeCode', dataIndex: 'jobTypeCode', sorter: true, sortOrder: list.sortOrderFor('jobTypeCode') },
    {
      title: 'Month',
      key: 'period',
      sorter: true,
      sortOrder: list.sortOrderFor('period'),
      render: (_, group) => MONTH_FORMAT.format(new Date(group.period)),
    },
    { title: 'On card', key: 'onCardCount', dataIndex: 'onCardCount', align: 'right', sorter: true, sortOrder: list.sortOrderFor('onCardCount') },
    { title: 'Off card', key: 'offCardCount', dataIndex: 'offCardCount', align: 'right', sorter: true, sortOrder: list.sortOrderFor('offCardCount') },
    {
      title: 'Off-card vs lane card price',
      key: 'variance',
      align: 'right',
      render: (_, group) => (group.variance ? `${group.variance.amountMinor > 0 ? '+' : ''}${formatMoney(group.variance)}` : '—'),
    },
    {
      title: 'Card',
      key: 'card',
      render: (_, group) => (group.cardIncomplete ? <Tag color="warning">No price on the card</Tag> : null),
    },
  ];
}
